import React from "react";
import axios from "axios";
import moment from "moment";
import toast from "react-hot-toast";

import useUser from "./useUser";
import InputSearchUser from "./InputSearchUser";
import useOnceEffect from "../../Hooks/useOnceEffect";

import { Avatar } from "./AdminUserPeding";
import { DATETIME_FORMAT } from "../../utils/Dates";

import "./admin.css";

const AdminUserDenied = () => {
  const userState = useUser();
  const { users, setUsers, setState } = userState;

  function aproveUser(id) {
    toast.success("en proceso, Aprobar", { duration: 3000 });

    axios
      .post(`user/update-profile-user/${id}/true`)
      .then(() => toast.success("Usuario aprobado", { duration: 3000 }));

    const old = users.filter((elm) => elm.userId !== id);
    setUsers(old);
  }

  useOnceEffect(() => {
    let is_mounted = true;

    axios.get("user/list-user-rejected").then((res) =>
      is_mounted
        ? setState({
            users: res.data,
            aux: res.data,
            user: null,
          })
        : null
    );

    return () => {
      is_mounted = false;
    };
  });

  return (
    <main id="admin" className="container mt-3">
      <InputSearchUser {...userState} />

      <table className="table">
        <thead>
          <tr>
            <th>Candidatos</th>
            <th>Perfil</th>
            <th>Fecha de registro</th>
            <th>Estado</th>
          </tr>
        </thead>

        <tbody>
          {users.map((elm, i) => (
            <tr key={i}>
              <td className="py-3">
                <div className="d-flex align-items-center">
                  <Avatar name={elm.name} />
                  &nbsp; {elm.name}
                </div>
              </td>
              <td className="py-3"> {elm.roles[0]?.description ?? ""}</td>
              <td>{moment(elm.fechaCreacion).format(DATETIME_FORMAT)}</td>
              <td className="py-3">
                <div className="d-flex justify-content-between">
                  <button
                    onClick={() => aproveUser(elm.userId)}
                    className="btn-aprove"
                  >
                    Aprobar
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
};

export default AdminUserDenied;
